class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  // ms of grace after the pointer leaves — enough to cross the label→panel gap
  static CLOSE_DELAY = 250;

  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Desktop: open on hover (the label anchor handles clicks / keyboard still toggles).
    if (window.matchMedia('(hover: hover) and (min-width: 990px)').matches) {
      this.addEventListener('mouseenter', this.open.bind(this));
      this.addEventListener('mouseleave', this.closeAfterDelay.bind(this));
    }
  }

  open() {
    clearTimeout(this.closeTimer);
    // Moving quickly between labels would otherwise leave the previous panel open
    // for CLOSE_DELAY ms, overlapping this one — shut the others without the grace.
    document.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) {
        clearTimeout(menu.closeTimer);
        menu.close();
      }
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  /*
   * The panel sits below a gap, so travelling from the label to the panel leaves
   * header-menu for a moment. Hold the panel open long enough to cross that gap —
   * re-entering (mouseenter) cancels the pending close.
   */
  closeAfterDelay() {
    clearTimeout(this.closeTimer);
    this.closeTimer = setTimeout(() => this.close(), HeaderMenu.CLOSE_DELAY);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
